<template>
  <ez-confirmation-modal ref="modal" :icon="null" @close="onClose">
    <template #title>Leave a note</template>
    <template #content>
      <ez-textarea
        ref="textarea"
        :formKey="formKey"
        name="message"
        label="Note"
        placeholder="Leave a note."
        :value="message"
        :rows="4"
        @onChange="onInput"
      />
    </template>
    <template #footer>
      <ez-button type="link" formType="button" @click="close">Cancel</ez-button>
      <ez-button
        formType="button"
        :disabled="!canSubmit"
        :is-loading="isLoading"
        @click="submit"
      >
        Submit
      </ez-button>
    </template>
  </ez-confirmation-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { EzConfirmationModal } from '@/components/ui/Modal';
import EzButton from '@/components/ui/Button';
import EzTextarea from '@/components/ui/Textarea/EzTextarea';
import { LOADING_KEY } from '@/util/constants';

export default {
  name: 'LeaveNoteModal',
  components: {
    EzConfirmationModal,
    EzButton,
    EzTextarea,
  },
  data() {
    return {
      formKey: 'leaveNote',
      message: '',
      noteId: null,
    };
  },
  computed: {
    ...mapGetters('loading', ['getLoading']),
    isLoading() {
      return this.getLoading(LOADING_KEY.CREATE_ORDER_NOTE)
        || this.getLoading(LOADING_KEY.UPDATE_ORDER_NOTE);
    },
    canSubmit() {
      return !!this.message.trim();
    },
  },
  methods: {
    open(note = null) {
      this.noteId = note?.id ?? null;
      this.message = note?.message ?? '';
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    onClose() {
      this.message = '';
      this.noteId = null;
      this.$refs.textarea.reset();
    },
    onInput(val) {
      this.message = val;
    },
    submit() {
      if (!this.canSubmit) return;
      this.$emit('submit', { message: this.message.trim(), noteId: this.noteId });
    },
  },
};
</script>
